import React, { useState, useContext, useEffect, useRef } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { Context } from '@routes/private/Editor/Context';
import { getCommonValue } from 'utils/multiEditing';
import {getTaggedVisibleElementsId} from 'utils/selectDescribe'

const MultiEditingTextBoxAttribute:React.FC<IProps> = (props) => {
  const inputRef = useRef(null);
  const [value, setValue]= useState("");
  const [lastValue, setLastValue]= useState("");
  const [characterCount, setCharacterCount]= useState(0);
  const context = useContext(Context);

  const handleFocusInput = () => {
    context.onMultiEditingFocus([props.selectDescribeFieldId]);
    const commonValue = getCommonValue(props.name,props.elementType,props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields);
    if(commonValue!=="") {
      setValue(commonValue);
      setLastValue(commonValue);
      if (commonValue) setCharacterCount(commonValue.length);
      else setCharacterCount(0);
    }
  }

  useEffect(() => {
    const commonValue = getCommonValue(props.name,props.elementType,props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields);
    setValue(commonValue);
    setLastValue(commonValue);
    if (commonValue) setCharacterCount(commonValue.length);
    else setCharacterCount(0);
    const ref: HTMLSpanElement|null = inputRef.current
    if (ref) {
      (ref as HTMLSpanElement).innerHTML = commonValue;
    }
}, [props.fieldId, context.editorStatus.setsSelected])

  const handleValidation = (e: any) => {
    const isDeleteOrBackspaceKey = ((e.keyCode||e.charCode)===8 || (e.keyCode||e.charCode)===46); 
    const isArrowKey = ((e.keyCode||e.charCode)===37 || (e.keyCode||e.charCode)===38 || (e.keyCode||e.charCode)===39 || (e.keyCode||e.charCode)===40); 
    if(isDeleteOrBackspaceKey || isArrowKey) return;
    const text = (e.target as HTMLSpanElement).innerText + String.fromCharCode(e.which || e.charCode);;
    const valid = checkValidText(text);
    if (!valid) {
      e.preventDefault()
    }
  }

  const checkValidText = (text: string): boolean => {
    const selection = document.getSelection();
    const isSelectingText = selection===undefined?false:(selection!.anchorOffset!==selection!.focusOffset);
    let valid: boolean = true;
    if (props.dataType==="NUMBER") {
      let re = /^[0-9.,]*$/;
      if (props.validation && props.validation.allowNegative) {
        re = /^[0-9.,-]*$/;
      }
      if (!re.test(text)) valid = false;
    }
    if (props.validation && props.validation.maxCharacters && text.length>props.validation.maxCharacters && !isSelectingText) valid=false;
    return valid;
  }

  const handleChangeInput = (e: any) => {
    const text = (e.target as HTMLSpanElement).innerText;
    if(lastValue!==text) {
      const elementsIds = getTaggedVisibleElementsId([props.selectDescribeFieldId], context.selectDescribe!.taggedFields, context.data);
      context.onCommandChange(props.name,text,elementsIds,undefined,undefined,true);
      setCharacterCount(text.length);
      setLastValue(text);
    } 
  }

  const handleArrowUpClick = () => {
    if(lastValue && lastValue!=="" && checkValidText(lastValue)){
      const newValue = (parseInt(lastValue) + 1).toString();
      handleArrowClick(newValue);
    }
  }

  const handleArrowDownClick = () => {
    if(lastValue && lastValue!=="" && checkValidText(lastValue)){
      const newValue = (parseInt(lastValue) - 1).toString();
      handleArrowClick(newValue);
    }
  }

  const handleArrowClick = (newValue: string) => {
    setValue(newValue);
    const elementsIds = getTaggedVisibleElementsId([props.selectDescribeFieldId], context.selectDescribe!.taggedFields, context.data);
    context.onCommandChange(props.name,newValue,elementsIds,undefined,undefined,true);
    setCharacterCount(newValue.length);
    setLastValue(newValue);
  }

  return (
    <S.TextBoxContainer onClick={() => handleFocusInput()}>
      <S.TextBoxInput 
        ref={inputRef}
        onKeyPress={(e) => handleValidation(e)} 
        onKeyUp={(e) => handleChangeInput(e)} 
        contentEditable={true}
        suppressContentEditableWarning={true}>
          {
            value
          }
      </S.TextBoxInput>
      {
        props.validation && props.validation.maxCharacters && props.dataType==="STRING" && 
        <S.TextBoxCharactersCount>
          {
            characterCount + "/" + props.validation.maxCharacters
          }
        </S.TextBoxCharactersCount>
      }
      {
        props.validation && props.validation.maxCharacters && props.dataType==="NUMBER" && 
        <S.ArrowsContainer>
          <S.ArrowContainer>
            <S.UpArrow onClick={()=>handleArrowUpClick()}/>
          </S.ArrowContainer>
          <S.ArrowContainer>
            <S.DownArrow onClick={()=>handleArrowDownClick()}/>
          </S.ArrowContainer>
        </S.ArrowsContainer>
      }
    </S.TextBoxContainer>
  );
}

export default MultiEditingTextBoxAttribute;